import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20education%20learning%20environment%20with%20abstract%20geometric%20shapes%20and%20soft%20warm%20gradients%2C%20minimalist%20design%2C%20inspirational%20study%20atmosphere%2C%20clean%20contemporary%20aesthetic%2C%20soft%20cream%20and%20warm%20coral%20tones&width=1800&height=900&seq=hero-bg-learning-01&orientation=landscape"
          alt="成人在线学习平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-4xl w-full">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <i className="ri-sparkling-line text-primary-300 text-sm"></i>
          <span className="text-background-50/90 text-sm font-medium">超过50万学员的信赖之选</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          成人在线学习
          <br />
          <span className="text-primary-300">提升职场竞争力的最佳选择</span>
        </h1>

        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          无论您是想获得专业资格证书、掌握新技能还是转型升级，灵活便捷的成人在线课程，随时随地学习，助您实现职业目标与个人成长。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/it-programming"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/25 whitespace-nowrap"
          >
            浏览全部课程
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-base hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12 flex-wrap">
          {[
            { value: '500+', label: '精品课程' },
            { value: '50万+', label: '累计学员' },
            { value: '98%', label: '好评率' },
            { value: '200+', label: '资深讲师' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
              <div className="text-background-300 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}